import { render, staticRenderFns } from "./ProductComponentModal.vue?vue&type=template&id=971f8d78&scoped=true&"
import script from "./ProductComponentModal.vue?vue&type=script&lang=js&"
export * from "./ProductComponentModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductComponentModal.vue?vue&type=style&index=0&id=971f8d78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971f8d78",
  null
  
)

export default component.exports